module.exports = __webpack_public_path__ + "img/circle.0aef6eb5.png";